import { render, staticRenderFns } from "./SecKillIndex.vue?vue&type=template&id=a60ae90e&scoped=true"
import script from "./SecKillIndex.vue?vue&type=script&lang=js"
export * from "./SecKillIndex.vue?vue&type=script&lang=js"
import style0 from "./SecKillIndex.vue?vue&type=style&index=0&id=a60ae90e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ae90e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a60ae90e')) {
      api.createRecord('a60ae90e', component.options)
    } else {
      api.reload('a60ae90e', component.options)
    }
    module.hot.accept("./SecKillIndex.vue?vue&type=template&id=a60ae90e&scoped=true", function () {
      api.rerender('a60ae90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/secKill/SecKillIndex.vue"
export default component.exports